document.addEventListener('ajaxProduct:added', function (event) {
	// when x added from pdp/quick view / cart recommendation add (qty * amount) Y to cart
	const addedProduct = event.detail.addedProduct;
	const xyRule = window.buyXGetY[addedProduct.id];
	const quantityFactor = parseInt(addedProduct.quantity);
	let formData = {
		items: xyRule
			.map((rule) => {
				return {
					id: rule.id,
					quantity: rule.amount * quantityFactor,
				};
			})
			.filter((item) => item.id && item.quantity > 0),
	};
	const isThereGiftLevel = window.giftLevels?.length > 0;
	const delaySeconds = isThereGiftLevel ? 500 : 0;
	if (formData.items.length > 0) {
		setTimeout(() => {
			fetch(window.Shopify.routes.root + 'cart/add.js', {
				body: JSON.stringify(formData),
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json',
				},
			})
				.then(async (response) => {
					document.dispatchEvent(new CustomEvent('cart:build'));
				})
				.catch((error) => {
					console.error('Error:', error);
				});
		}, delaySeconds);
	}
});
document.addEventListener('cart:sync-x-y', function (event) {
	const changedVariant = event.detail.changedVariant;
	const changedVariantId = parseInt(changedVariant.id);
	const changedVariantQTY = parseInt(changedVariant.qty);
	// only y products that are connected to the changed x product should be updated.
	//
	const toUpdatesVariants = window.buyXGetY[changedVariantId].map((rule) => rule.id).filter((id) => id);
	if (toUpdatesVariants.length <= 0) {
		return;
	}
	// removing the data that is not needed
	const cartItems = event.detail.cart?.items?.map((item) => ({
		id: item.variant_id,
		quantity: item.quantity,
	}));
	// if the changedVariant is removed from the cart, the cartItems wont include the changedVariant
	// so we add it to the cartItems manually with the changed quantity (0)
	const changedItemInCart = cartItems.find((item) => item.id === changedVariantId);
	if (!changedItemInCart) {
		cartItems.push({
			id: changedVariantId,
			quantity: changedVariantQTY,
		});
	}
	// get all the rules that are connected to the current cartItems
	const rules = cartItems.reduce((acc, item) => {
		const xyRule = window.buyXGetY[item.id];
		const quantityFactor = parseInt(item.quantity);
		xyRule.forEach((rule) => {
			if (rule.id && rule.amount > 0) {
				acc.push({
					id: rule.id,
					quantityFactor,
					amount: rule.amount,
				});
			}
		});
		return acc;
	}, []);
	// we only want to update the rules that are connected to the changedVariant
	const toUpdateRules = rules.filter((rule) =>  toUpdatesVariants.includes(rule.id));
	const updates = {};
	toUpdateRules.forEach((rule) => {
		// if more than one rule is connected to the same product, we need to sum the amounts
		const qtyFromOtherProducts = updates[rule.id] || 0;
		updates[rule.id] = rule.amount * rule.quantityFactor + qtyFromOtherProducts;
	});
	const isThereGiftLevel = window.giftLevels?.length > 0;
	const delaySeconds = isThereGiftLevel ? 500 : 0;
	if (Object.keys(updates).length > 0) {
		setTimeout(() => {
			fetch(theme.routes.cartUpdateUrl, {
				body: JSON.stringify({ updates }),
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json',
				},
			})
				.then((response) => {
					if (response.ok) {
						document.dispatchEvent(new CustomEvent('cart:build'));
					}
				})
				.catch((error) => {
					console.error('Error:', error);
				});
		}, delaySeconds);
	}
});
